export default "__VITE_ASSET__BCNd1Kvl__"